<template>
  <div>
    <!-- หน้ารอโหลด -->
    <div
      v-if="isLoading"
    >
      <div class="loading-spinner">
        <div class="dot" />
        <div class="dot" />
        <div class="dot" />
      </div>
    </div>

    <div v-else>
      <div>
        <h2> {{ $t('search') }}</h2>
        <input
          v-model="searchQuery"
          type="text"
          :placeholder="$t('searchcateAndsubname')"
          class="form-input"
        >
      </div>
      <!-- Form for Adding/Editing Category -->
      <div class="form-container">
        <h2>{{ isEditingCategory ? $t('editlist') : $t('addcate') }}</h2>
        <form @submit.prevent="saveCategory">
          <input
            v-model="currentCategory.name"
            maxlength="50"
            :placeholder="$t('catename')"
            required
            class="form-input"
          >
          <b-button
            type="submit"
            variant="primary"
          >
            {{ isEditingCategory ? $t('edit') : $t('add') }}
          </b-button>
          <b-button
            variant="secondary"
            @click="resetToAddCategory"
          >
            {{ $t('reset') }}
          </b-button>
        </form>
      </div>

      <!-- Form for Adding/Editing Subcategory -->
      <div
        v-if="selectedCategory"
        class="form-container"
      >
        <h2>{{ isEditingSubCategory ? $t('editsubcate') : $t('addsubcate') }} {{ currentCategory.name }}</h2>
        <form @submit.prevent="saveSubCategory">
          <input
            v-model="currentSubCategory.name"
            maxlength="50"
            :placeholder="$t('subcatename')"
            required
            class="form-input"
          >
          <b-button
            type="submit"
            variant="primary"
          >
            {{ isEditingSubCategory ? $t('edit') : $t('addlist') }}
          </b-button>

        </form>
      </div>

      <!-- Categories List -->
      <div class="list-container">
        <ul class="category-list">
          <li
            v-for="category in filteredCategories"
            :key="category.id"
            class="category-item"
          >
            <span class="category-name">{{ category.name }}</span>
            <div class="button-group">
              <b-icon
                icon="pencil"
                class="clickable-icon icon-large text-warning"
                aria-hidden="true"
                @click="editCategory(category)"
              />

              <b-icon
                icon="trash"
                class="clickable-icon icon-large text-danger"
                aria-hidden="true"
                @click="deleteCategory(category.id)"
              />
              <b-icon
                :icon="isSubCategoriesVisible[category.id] ? 'arrow-up' : 'arrow-down'"
                class="clickable-icon icon-large"
                aria-hidden="true"
                @click="toggleSubCategories(category.id)"
              />
            </div>

            <!-- Show subcategories directly under the category -->
            <ul
              v-if="isSubCategoriesVisible[category.id]"
              class="subcategory-list"
            >
              <li
                v-for="subCategory in category.subCategories"
                :key="subCategory.id"
                class="subcategory-item"
              >
                <span class="subcategory-name">{{ subCategory.name }}</span>
                <div class="button-group">
                  <b-icon
                    icon="pencil"
                    class="clickable-icon icon-large text-warning"
                    aria-hidden="true"
                    @click="editSubCategory(subCategory, category.id)"
                  />
                  <b-icon
                    icon="trash"
                    class="clickable-icon icon-large text-danger"
                    aria-hidden="true"
                    @click="deleteSubCategory(subCategory.id)"
                  />
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- Confirmation Modal -->
      <div
        v-if="showConfirmationModal"
        class="modal-overlay"
      >
        <b-modal
          v-model="showConfirmationModal"
          :title="$t('delconfirm')"
          :ok-title="$t('yes')"
          :cancel-title="$t('cancel')"
          @ok="confirmDelete"
        >
          <p class="my-4">
            {{ $t('confirmdelete') }}
          </p>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import apiMst from '@/services/masterDate'

export default {
  data() {
    return {
      searchQuery: '',
      categories: [],
      selectedCategory: null,
      currentCategory: { id: null, name: '' },
      currentSubCategory: { id: null, name: '', categoryId: null },
      isEditingCategory: false,
      isEditingSubCategory: false,
      loading: false,
      errorMessage: '',
      showConfirmationModal: false,
      itemToDelete: null,
      isSubCategoriesVisible: {}, // ใช้ Object เพื่อเก็บสถานะการแสดง
      isLoading: true,
    }
  },
  computed: {
    filteredCategories() {
      return this.categories.filter(category => {
      // ค้นหาชื่อหมวดหมู่หลัก (category)
        const categoryMatches = category.name.toLowerCase().includes(this.searchQuery.toLowerCase())

        // ค้นหาชื่อหมวดหมู่ย่อย (subcategories) หากมีข้อมูล
        const subCategoriesMatch = category.subCategories && category.subCategories.some(subCategory => subCategory.name.toLowerCase().includes(this.searchQuery.toLowerCase()))

        // คืนค่าหมวดหมู่ที่ตรงกับการค้นหาหรือหมวดหมู่ย่อยที่ตรงกับการค้นหา
        return categoryMatches || subCategoriesMatch
      })
    },
  },
  created() {
    this.fetchCategories()
  },
  methods: {
    toggleSubCategories(categoryId) {
      // สลับการแสดง/ซ่อนหมวดหมู่ย่อย
      this.$set(this.isSubCategoriesVisible, categoryId, !this.isSubCategoriesVisible[categoryId])
      if (!this.isSubCategoriesVisible[categoryId]) {
        this.selectedCategory = null // ถ้าซ่อนรายการ, ไม่เลือกหมวดหมู่
      } else {
        this.selectedCategory = this.categories.find(cat => cat.id === categoryId)
        this.fetchSubCategories(categoryId)
      }
    },

    async fetchCategories() {
      try {
        this.isLoading = true
        const response = await apiMst.get('/device')
        this.categories = response.data
        this.categories.forEach(category => {
          if (!Array.isArray(category.subCategories)) {
            category.subCategories = []
          }
          // เริ่มต้นสถานะการแสดงของหมวดหมู่ย่อย
          this.$set(this.isSubCategoriesVisible, category.id, false)
        })
      } catch (error) {
        this.errorMessage = 'Error fetching categories.'
        console.error('Error fetching categories:', error)
      } finally {
        this.isLoading = false
      }
    },

    async fetchSubCategories(categoryId) {
      try {
        this.isLoading = true
        const response = await apiMst.get(`/subdevice/${categoryId}`)
        const category = this.categories.find(cat => cat.id === categoryId)
        if (category) {
          category.subCategories = response.data || []
          this.selectedCategory = { ...category } // อัปเดต selectedCategory ด้วยข้อมูลล่าสุด
        }
      } catch (error) {
        this.errorMessage = 'Error fetching subcategories.'
        console.error('Error fetching subcategories:', error)
      } finally {
        this.isLoading = false
      }
    },

    async saveCategory() {
      try {
        this.isLoading = true
        if (this.isEditingCategory) {
          await apiMst.put(`/device/${this.currentCategory.id}`, this.currentCategory)
        } else {
          await apiMst.post('/deviceAdd', this.currentCategory)
        }
        this.fetchCategories()
        this.resetCategoryForm()
      } catch (error) {
        this.errorMessage = 'Error saving category.'
        console.error('Error saving category:', error)
      } finally {
        this.isLoading = false
      }
    },

    async deleteCategory(categoryId) {
      this.itemToDelete = categoryId
      this.showConfirmationModal = true
    },

    async deleteSubCategory(subCategoryId) {
      this.itemToDelete = subCategoryId
      this.showConfirmationModal = true
    },

    async confirmDelete() {
      if (this.itemToDelete) {
        try {
          this.loading = true
          const isCategory = this.categories.some(cat => cat.id === this.itemToDelete)
          if (isCategory) {
            await apiMst.delete(`/deviceDel/${this.itemToDelete}`)
          } else {
            await apiMst.delete(`/subdeviceDel/${this.itemToDelete}`)
            if (this.selectedCategory) {
              await this.fetchSubCategories(this.selectedCategory.id) // อัปเดตหมวดหมู่ย่อยหลังจากลบ
            }
          }
          await this.fetchCategories()
        } catch (error) {
          this.errorMessage = 'Error deleting item.'
          console.error('Error deleting item:', error.response ? error.response.data : error.message)
          this.$bvToast.toast(this.$t('useddelete'), {
            title: this.$t('error'),
            variant: 'danger',
            solid: true,
            appendToast: true,
            autoHideDelay: 5000,
            toaster: 'b-toaster-top-right',
          })
        } finally {
          this.loading = false
          this.itemToDelete = null
          this.showConfirmationModal = false
        }
      }
    },

    async saveSubCategory() {
      try {
        this.loading = true
        const payload = {
          name: this.currentSubCategory.name,
          category: { id: this.selectedCategory.id },
        }

        if (this.isEditingSubCategory) {
          await apiMst.put(`/subdeviceUpdate/${this.currentSubCategory.id}`, payload)
        } else {
          await apiMst.post('/subdeviceAdd', payload)
        }

        await this.fetchSubCategories(this.selectedCategory.id) // รีเฟรชข้อมูลหมวดหมู่ที่เลือก
        this.resetSubCategoryForm()
      } catch (error) {
        this.errorMessage = 'Error saving subcategory.'
        console.error('Error saving subcategory:', error)
      } finally {
        this.loading = false
      }
    },

    cancelDelete() {
      this.itemToDelete = null
      this.showConfirmationModal = false
    },

    editCategory(category) {
      this.currentCategory = { ...category }
      this.isEditingCategory = true
    },

    editSubCategory(subCategory, categoryId) {
      this.currentSubCategory = { ...subCategory, categoryId }
      this.isEditingSubCategory = true
    },

    resetCategoryForm() {
      this.currentCategory = { id: null, name: '' }
      this.isEditingCategory = false
    },

    resetSubCategoryForm() {
      this.currentSubCategory = { id: null, name: '', categoryId: null }
      this.isEditingSubCategory = false
    },
    resetToAddCategory() {
      this.resetCategoryForm()
      this.resetSubCategoryForm()
      this.selectedCategory = null
    },
  },
}
</script>

  <style scoped>
  .container {
    padding: 20px;
  }

  .form-container {
    margin-top: 50px;
  }

  .category-name{
    font-size: large;
    font-weight: bold;
  }

  .subcategory-name{
    font-size: medium;
  }

  .form-input {
    padding: 10px;
    margin-right: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .btn {
    padding: 10px 20px;
    margin: 5px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }

  .list-container {
    margin-top: 20px;
  }

  .category-list, .subcategory-list {
    list-style-type: none;
    padding: 0;
  }

  .category-item, .subcategory-item {
    padding: 10px;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    text-align: center;
  }

  .loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.clickable-icon {
  cursor: pointer; /* เปลี่ยนเคอร์เซอร์เป็นมือเมื่อชี้ที่ไอคอน */
  margin-right: 10px; /* เพิ่มระยะห่างระหว่างไอคอน */
  margin-bottom: 5px;
}
.icon-large {
  font-size: 24px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}
.icon-edit {
  font-size: 16px; /* กำหนดขนาดไอคอน (ปรับตามต้องการ) */
}

.dot {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background-color: #5496ec;
  animation: bounce 0.6s infinite alternate;
}

.dot:nth-child(2) {
  animation-delay: 0.2s;
}

.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-20px);
  }
}
</style>
